/**
 * QuietModeChip — persistent visual indicator for quiet mode.
 *
 * Renders ONLY when quiet mode is ON. Clicking the chip turns it OFF
 * (equivalent to typing "turn answers back on"). Verbose mode users
 * never see anything from this component.
 *
 * Placement: rendered alongside the query field by App.js when getQuietMode()
 * is true. Component does not own the mode state itself — it is a pure
 * visual + click affordance, parent component holds the truth.
 */
import React from 'react';
import { COPY } from '../lib/quietMode';

export function QuietModeChip({ active, onClick }) {
  if (!active) return null;

  return (
    <button
      type="button"
      data-testid="quiet-mode-chip"
      onClick={onClick}
      className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-medium text-amber-700 bg-amber-50 border border-amber-200 hover:bg-amber-100 transition-colors cursor-pointer focus:outline-none focus:ring-2 focus:ring-amber-300"
      title={COPY.chipLabel}
    >
      <span>{COPY.chipLabel}</span>
    </button>
  );
}

export default QuietModeChip;
